<template>
  <div
    class="msg_wrapper"
  >
    <!--    <button @click="$emit('update:show', false)" class="back_btn">-->
    <!--      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
    <!--        <path d="M5 12H19" stroke="#121111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--        <path d="M10 7L5 12" stroke="#121111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--        <path d="M10 17L5 12" stroke="#121111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
    <!--      </svg>-->
    <!--    </button>-->
    <!--    <div class="auth_title">Введи код из SMS</div>-->

    <HeadNew
      :back-action="() => $emit('update:show', false)"
    />

    <div>
      <Typography
        variant="v24-700"
        center
        style="margin-top: 24px; margin-bottom: 16px"
      >
        {{ t(`guest:Otp.${isTelegramOTPChannel ? 'TitleTelegram' : 'TitleSms'}`) }}
      </Typography>
      <div
        style="margin-bottom: 48px"
      >
        <Typography
          variant="v14-400"
          color="var(--text-notice-color)"
          center
          style="margin-bottom: 12px; line-height: 24px"
        >
          {{ t(`guest:Otp.${isTelegramOTPChannel ? 'TextTelegram' : 'TextSms'}`, { phone: phone.replace(/[  ]/g, ' ') }) }}
        </Typography>
        <Typography
          v-if="appType === appTypes.TELEGRAM"
          variant="v14-400"
          color="var(--text-notice-color)"
          center
        >
          {{ t("guest:Otp.Informs") }}
        </Typography>
      </div>
    </div>

    <div
      class="confirm_input_wrapper"
    >
      <input
        v-for="i in 4"
        :key="i"
        :ref="`confirm_input_${i - 1}`"
        v-model="code[i - 1]"
        v-maska
        type="text"
        data-maska="#"
        pattern="[0-9]*"
        inputmode="tel"
        :class="error ? 'error_input' : ''"
        @keydown="handleKeyDown($event, i - 1, code[i - 1])"
        @input="handleKeyUp($event, i - 1, code[i - 1])"
      />
    </div>
    <div
      v-if="error"
      class="error_text"
    >
      <img
        src="../../assets/images/error_input.svg"
        alt=""
      />
      {{ errorMsg ? errorMsg : 'Неверный код, попробуй ещё раз' }}
    </div>
    <div
      v-if="timerExpired"
      class="msg_time"
    >
      <div>Не приходит код?</div>
      <div
        class="btn"
        @click="sendCode"
      >
        Отправить код подтверждения в SMS
      </div>
    </div>
    <div
      v-else-if="!!timer"
      class="msg_time"
    >
      Вы можете отправить код повторно <br/> через <span>{{ timer }}</span>
    </div>
  </div>
</template>

<script>
import store from "@/store/store.js"
import { appAxios } from "@/axios.js"
import { appType, appTypes } from '@/appType/appType.js'
import { vMaska } from "maska"
import { t } from 'i18next'
import { timeDiff } from '@/utils/timeLeft'
import * as libPhoneNumber from 'libphonenumber-js'

import AppButton from "@/components/UI/AppButton.vue";
import AppLink from "@/components/AppLink.vue"
import Card from "@/components/UI/Card.vue"
import HeadNew from '@/components/Head.vue'
import Typography from "@/components/UI/Typography.vue"

export default {
  name: "CheckMsg",
  components: {
    AppButton,
    Typography,
    AppLink,
    Card,
    HeadNew
  },
  directives: {
    maska: vMaska
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    msg_code: String,
    phone: String,
    error: {
      type: Boolean,
      default: false,
    },
    errorMsg: {
      type: String,
      default: '',
    }
  },
  emits: ["update:show", "update:msg_code"],
  data() {
    return {
      timeDiff,
      libPhoneNumber,
      bindedObject: {
        masked: "",
        unmasked: "",
        completed: false,
      },
      code: ["", "", "", ""],
      appType,
      appTypes,
      isTelegramOTPChannel: true,
      timer: null,
      timerExpired: true
    };
  },
  computed: {
    store() {
      return store
    }
  },
  mounted() {
    this.$refs.confirm_input_0[0].focus()

    // const isBodybaseProject = store.state.app?.appData?.pageTitle === 'bodybase'
    // if (isBodybaseProject) {
    //   this.isTelegramOTPChannel = false
    // }

    this.startTimer(60000, (state) => {
      this.timer = state.timeString
      this.timerExpired = state.isExpired
    })
  },
  methods: {
    t,
    handleKeyDown(event, idx, value) {
      if (event.key === "Tab") {
        event.preventDefault();
      }
      if (event.key === "Backspace") {
        if (!value && idx !== 0) {
          this.$refs[`confirm_input_${idx - 1}`][0].focus();
        }
      }
    },
    handleKeyUp(event, idx, value) {
      if (event.key !== "Backspace" && idx !== 3 && value.match(/\d+/g)) {
        this.$refs[`confirm_input_${idx + 1}`][0].focus();
      }
      this.$emit("update:msg_code", this.code.join(""));
    },
    clickOpenURL(url) {
      Object.assign(document.createElement('a'), {
        target: '_blank',
        rel: 'noopener noreferrer',
        href: url,
      }).click()
    },
    async sendCode() {
      await appAxios.auth.sendAuthCode({
        phone: this.phone,
        otp_provider: "sms"
      })

      this.startTimer(60000, (state) => {
        this.timer = state.timeString
        this.timerExpired = state.isExpired

        this.isTelegramOTPChannel = false
      });
    },
    startTimer(ms, onTick) {
      let remaining = ms;

      const interval = setInterval(() => {
        remaining -= 1000;

        const totalSec = Math.max(0, Math.floor(remaining / 1000));
        const minutes = String(Math.floor(totalSec / 60)).padStart(2, '0');
        const seconds = String(totalSec % 60).padStart(2, '0');

        const status = {
          timeString: `${minutes}:${seconds}`,
          isExpired: remaining <= 0
        };

        onTick(status);

        if (status.isExpired) clearInterval(interval);
      }, 1000);

      return interval
    }
  }
}

</script>

<style lang="scss">
@import "@/assets/variables";

.msg_wrapper {
  padding: 12px 16px 16px;
  .back_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
  }
  .error_text {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 11px;
    color: var(--text-error-color);
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0%;
    text-align: left;
    background: transparent;
    padding: 0;
    margin-bottom: 0;
  }
}

.dark-theme .msg_wrapper .back_btn svg path {
  stroke: #fff;
}

.msg_wrapper .auth_title {
  text-align: center;
  margin-bottom: 16px;
  //styleName: Display XS/Bold;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
}

.phone {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;

  label {
    color: var(--text-notice-color);
    font-variant-numeric: lining-nums proportional-nums;
    font-family: "Raleway", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    text-align: center;
  }

  input {
    display: none;
  }

  span {
    font-variant-numeric: lining-nums proportional-nums;
    color: var(--text-notice-color);
    font-family: Raleway, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0%;
    text-align: center;
  }
}

.confirm_input_wrapper {
  display: flex;
  justify-content: center;
  gap: 16px;
  align-items: flex-start;
  text-align: center;
  margin-bottom: 27px;
}

.confirm_input_wrapper input {
  width: 56px;
  height: 72px;
  text-align: center;
  color: var(--text-primary-color);
  border-bottom: 2px solid var(--form-border-base-color);
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: "Raleway", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
}

@keyframes inputAnimation {
  0% {
    border-bottom: 2px solid var(--app-accent-light-color);
  }
  50% {
    border-bottom: 2px solid transparent;
  }
  100% {
    border-bottom: 2px solid var(--app-accent-light-color);
  }
}

.confirm_input_wrapper input:focus {
  animation: 1.3s ease inputAnimation infinite;
}

.confirm_input_wrapper .error_input {
  color: var(--text-error-color);
  border-bottom: 2px solid var(--text-error-color);
}

.msg_time {
  color: var(--text-notice-color);
  font-variant-numeric: lining-nums proportional-nums;
  font-family: "Raleway", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  text-align: center;
  margin-top: 40px;

  .btn {
    cursor: pointer;
    color: var(--text-primary-color);
    font-weight: 500;
  }
}

.msg_time span {
  color: var(--app-accent-light-color);
}

.dark-theme .msg_time span {
  color: var(--text-primary-color);
}
</style>
